document.addEventListener("DOMContentLoaded", function () {

  var lensAndCoUrlParams = new URLSearchParams(window.location.search);
  const lensAndCoUrl = decodeURIComponent(lensAndCoUrlParams.get('lensandco'));

  const delayBetweenSteps = 1300;
  const progressBar = document.querySelector(".ombraz__rx-progress-bar");
  const steps = document.querySelectorAll(".ombraz__rx-progress-step");
  const numSteps = steps.length;
  const stepWidth = 100 / numSteps;
  let currentStepIndex = 0;
  let progress = 0;

  const redirectUrl = lensAndCoUrl;

  // Initialize progress bar width
  progressBar.style.width = stepWidth + "%";

  // Function to update progress bar width
  function updateProgress() {
    progress += stepWidth;
    progressBar.style.width = progress + "%";

    Array.from(steps).forEach((step, index) => {
      if (index === currentStepIndex) {
        step.classList.add("active");
      }
    });
  }

  // Function to show the next step
  function showNextStep() {
    // Update progress bar
    updateProgress();

    // Increment the step index or reset it if it exceeds the number of steps
    currentStepIndex = (currentStepIndex + 1) % numSteps;

    // Check if all steps have been shown
    if (currentStepIndex === 0) {
      setTimeout(() => {
        window.location.href = redirectUrl;
      }, delayBetweenSteps);
      return;
    }

    // Show the next step after a delay
    setTimeout(showNextStep, delayBetweenSteps);
  }

  // Start showing the next steps
  setTimeout(showNextStep, delayBetweenSteps);
});